import React from "react";
import { TableCell, TableRow, Tooltip } from "@material-ui/core";
import Button from "../DesignSystem/button";
import TitleSubtitle from "../DesignSystem/Table/Cells/TitleSubtitle";
import ElipsisCell from "../DesignSystem/Table/Cells/ElipsisTextCell";
import { HeadCellType, PortColor, YearDaysForCalculation, getPortChargePerMonth } from "../../utils/appConstants";
import DollarIcon from "../../assets/images/dollar.svg";
import { currencyFormatter, getCityState } from "../../utils/methods";
import LinkImage from "../ResourceImages/Link";

export const headCells: HeadCellType[] = [
  {
    id: "nne_name",
    align: "left",
    disablePadding: false,
    sortEnabled: true,
    label: "Near End Network Element",
    // searchEnabled: true,
    width: "18%",
  },
  {
    id: "fne_name",
    align: "left",
    disablePadding: false,
    sortEnabled: true,
    // searchEnabled: true,
    label: "Far End Network Element",
    width: "18%",
  },
  {
    id: "seller",
    align: "left",
    disablePadding: false,
    sortEnabled: true,
    label: "Service Description",
    width: "15%",
  },
  {
    id: "on_contract_price",
    align: "right",
    disablePadding: false,
    sortEnabled: true,
    label: "Contract Price",
    width: "10%",
  },
  {
    id: "on_demand_price",
    align: "right",
    disablePadding: false,
    sortEnabled: true,
    label: "On Demand Price",
    width: "10%",
  },
  {
    id: "status",
    align: "center",
    disablePadding: false,
    sortEnabled: false,
    label: "Status",
    width: "14%",
  },
  {
    id: "action",
    align: "left",
    disablePadding: false,
    sortEnabled: false,
    label: "Action",
    width: "15%",
  },
];

interface TableDataProps {
  bandwidthPort: any;
  handlePurchaseOpen: () => void;
}
const TableData: React.FC<TableDataProps> = ({ bandwidthPort, handlePurchaseOpen }) => {
  const onContractPrice = (
    <div className="price-title">
      {bandwidthPort.on_contract_price === 0 ? (
        "-"
      ) : (
        <>
          {" "}
          <img src={DollarIcon} alt="Dollar" />
          <label>{`${currencyFormatter(bandwidthPort.on_contract_price + getPortChargePerMonth(bandwidthPort) * 2)}/month`}</label>
        </>
      )}
    </div>
  );

  const onDemandPerMonth = bandwidthPort.on_demand_price
    ? ((parseFloat(bandwidthPort.on_demand_price) / 100) * ((60 * 24 * YearDaysForCalculation) / 12) + getPortChargePerMonth(bandwidthPort) * 2).toFixed(2)
    : 0;
  const onDemandPrice = (
    <div className="price-title">
      {onDemandPerMonth === 0 ? (
        "-"
      ) : (
        <>
          <Tooltip
            classes={{
              tooltip: "tooltip",
            }}
            arrow
            placement="left"
            title="On Demand Services are priced Per Minute. The Price Per Month will vary depending on length of the calendar month."
          >
            <span>&cong;&nbsp;</span>
          </Tooltip>
          <img src={DollarIcon} alt="Dollar" />
          <label>{currencyFormatter(parseFloat(onDemandPerMonth))}</label>
        </>
      )}
    </div>
  );
  const linkColor = bandwidthPort.listing_verified ? PortColor.Green : PortColor.Grey;
  const nearColor = bandwidthPort.near_verified ? PortColor.Green : PortColor.Grey;
  const nearPlugColor = bandwidthPort.near_verified ? PortColor.LightGreen : PortColor.LightGrey;
  const farColor = bandwidthPort.far_verified ? PortColor.Green : PortColor.Grey;
  const farPlugColor = bandwidthPort.far_verified ? PortColor.LightGreen : PortColor.LightGrey;
  return (
    <TableRow>
      <TitleSubtitle
        width="18%"
        maxWidth="15vw"
        align="left"
        title={bandwidthPort.near_network_element}
        subTitle={getCityState(bandwidthPort, "near_node_") || "-"}
        boldTitle
        isSwipeIcon
      />
      <TitleSubtitle
        width="18%"
        maxWidth="15vw"
        align="left"
        title={bandwidthPort.far_network_element}
        subTitle={getCityState(bandwidthPort, "far_node_") || "-"}
        boldTitle
      />
      <TitleSubtitle
        width="15%"
        maxWidth="15vw"
        align="left"
        title={bandwidthPort.organization_name}
        subTitle={bandwidthPort.service_description}
        boldSubtitle
      />

      <TitleSubtitle
        width="10%"
        maxWidth="15vw"
        align="right"
        titleNode={onContractPrice}
        title=""
        subTitle={bandwidthPort.on_contract_price === 0 ? "" : "24 Month Contract"}
        boldTitle
      />
      <TitleSubtitle
        width="10%"
        maxWidth="15vw"
        align="right"
        titleNode={onDemandPrice}
        title=""
        subTitle={onDemandPerMonth === 0 ? "" : "Per Month"}
        boldTitle
      />
      <TitleSubtitle
        width="14%"
        maxWidth="15vw"
        align="center"
        title=""
        titleNode={<LinkImage linkColor={linkColor} leftColor={nearColor} leftPlug={nearPlugColor} rightColor={farColor} rightPlug={farPlugColor} />}
      />
      <TableCell align="left" width="15%">
        <Tooltip
          placement="left"
          title={
            bandwidthPort.isDisable ? (
              <div>
                <div>This Link was put for sale by your organization.</div>
              </div>
            ) : (
              "This Link is for sale"
            )
          }
          classes={{
            tooltip: "tooltip",
          }}
          arrow
        >
          <div>
            <Button disabled={bandwidthPort.isDisable} className="btn-purchase" variant="success" text="Terms of Service" onClick={handlePurchaseOpen} />
          </div>
        </Tooltip>
      </TableCell>
    </TableRow>
  );
};

export default TableData;
